module.exports = __webpack_public_path__ + "static/img/home_service_01.zh.95f6f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_service_01.zh.png
// module id = sT7O
// module chunks = 34